<template>
  <div :class="_.recommend">
    <div v-if="theme.titleType !== 'none'" :class="_.hd">
      <img
        v-if="theme.titleType === 'url'"
        :src="theme.title"
        :class="_.image"
      />
    </div>
    <div :class="_.bd">
      <div :class="_.category">
        <div
          v-for="(item, index) in data"
          :key="index"
          v-track="{
            name: '商品推荐-分类栏',
            id: `${componentId}-category`,
            resource: item,
            index: index,
          }"
          :class="[_.item, categoryIndex === index && _.active]"
          @click="categoryIndex = index"
        >
          <img :src="item.icon" :class="_.icon" />
          <img :src="item.extendData" :class="_.activeIcon" />
        </div>
      </div>
      <div :key="categoryIndex" :class="_.list">
        <div
          v-for="(item, index) in data[categoryIndex].childList"
          :key="index"
          v-track="{
            name: '商品推荐-商品',
            id: `DianJiZiDingYiYeZiYuan`,
            resource: item,
            index: index,
            extra: getTrackExtra(item, index),
          }"
          :class="_.item"
          @click="$dmbcResourceClick(item)"
        >
          <img :src="item.icon" :class="_.cover" />
          <div :class="_.content">
            <div :class="_.name">
              {{ item.title }}
            </div>
            <div :class="_.grow"></div>
            <div :class="_.extra">
              <div :class="_.left">
                <div v-if="theme.showSales" :class="_.sales">
                  销量 {{ item.sales }}
                </div>
                <div :class="_.price"><span>¥</span>{{ item.discountAmt }}</div>
              </div>
              <div :class="_.button">{{ theme.buttonText }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    data: () => ({
      categoryIndex: 0,
    }),
  })
</script>

<style lang="scss" module="_">
  .recommend {
    border-radius: var(--border-radius);
    font-size: 0;

    .hd {
      .image {
        width: 100%;
        height: auto;
        border-top-left-radius: var(--border-radius);
        border-top-right-radius: var(--border-radius);
      }
    }

    .bd {
      position: relative;
      display: flex;
      align-items: stretch;
      background: #ffffff;
      border-radius: 12px;
      overflow: hidden;
      padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
        var(--padding-left);

      .category {
        flex-shrink: 0;
        width: 90px;

        .item {
          width: 100%;

          .icon,
          .activeIcon {
            width: 100%;
          }

          .icon {
            display: block;
          }

          .activeIcon {
            display: none;
          }

          &.active {
            .icon {
              display: none;
            }

            .activeIcon {
              display: block;
            }
          }
        }
      }

      .list {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 90px;
        flex-grow: 1;
        overflow: auto;
        padding: 12px 10px;
        box-sizing: border-box;

        .item {
          display: flex;
          align-items: stretch;

          .cover {
            flex-shrink: 0;
            width: 74px;
            height: 74px;
            object-fit: cover;
            border-radius: 4px;
          }

          .content {
            margin-left: 8px;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .name {
              font-size: 12px;
              color: #333333;
              line-height: 17px;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .grow {
              flex-grow: 1;
            }

            .extra {
              display: flex;
              align-items: flex-end;

              .left {
                flex-grow: 1;

                .sales {
                  font-size: 11px;
                  color: #999999;
                  line-height: 16px;
                }

                .price {
                  font-size: 14px;
                  font-weight: bold;
                  color: #fa0f0f;
                  line-height: 20px;

                  span {
                    font-size: 10px;
                    font-weight: normal;
                    color: #fa0f0f;
                    line-height: 14px;
                  }
                }
              }

              .button {
                flex-shrink: 0;
                width: 64px;
                height: 22px;
                background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
                border-radius: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 11px;
                color: #ffffff;
              }
            }
          }

          + .item {
            margin-top: 12px;
          }
        }
      }
    }
  }
</style>
